import { render, staticRenderFns } from "./remote-cabinet-charge.vue?vue&type=template&id=8f2fb082&"
import script from "./remote-cabinet-charge.vue?vue&type=script&lang=js&"
export * from "./remote-cabinet-charge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports